import { PowerOff } from "lucide-react";

import { ColocaAlertDialog } from "@/shared/components/feedback/ColocaAlertDialog";
import useTranslations from "@/shared/lang/useTranslations";

import type { AdminOrganization } from "../types/organizationsAdmin.types";

export interface DisablePayoutBatchesDialogProps {
  organization: AdminOrganization | null;
  isPending: boolean;
  onConfirm: (organization: AdminOrganization) => void;
  onOpenChange: (open: boolean) => void;
}

/** Switching batch payouts off takes the module away from the organization's members, so it is confirmed. */
export function DisablePayoutBatchesDialog({
  organization,
  isPending,
  onConfirm,
  onOpenChange,
}: DisablePayoutBatchesDialogProps) {
  const { t } = useTranslations("organizations");

  return (
    <ColocaAlertDialog
      open={organization !== null}
      onOpenChange={onOpenChange}
      media={<PowerOff className="size-8" />}
      title={t("disable_dialog_title", { name: organization?.name ?? "" })}
      description={t("disable_dialog_description")}
      confirmLabel={t("disable_dialog_confirm")}
      confirmVariant="destructive"
      confirmDisabled={isPending}
      cancelLabel={t("disable_dialog_cancel")}
      onConfirm={() => organization && onConfirm(organization)}
    />
  );
}
